import {
    ACTUALIZAR_LIST_HERRAMIENTA,
    AGREGAR_HERRAMIENTA,
  } from "./herramientaActions";

  const herramientaReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_HERRAMIENTA: {
            return {
                ...state,
                herramientaIDLista: action.payload
            }
        };

        case AGREGAR_HERRAMIENTA:{
            return {
                 ...state,
                 herramientaIDLista: [action.payload, ...state.herramientaIDLista]
             }
         };

        default:
            return state;

    }
  }

  export default herramientaReducer;
